import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const ROTATE = trigger('rotate', [
  state('initial', style({ transform: 'rotate(0)', display: 'block' })),
  state('final', style({ transform: 'rotate(180deg)', display: 'block' })),

  state('initialReverse', style({ transform: 'rotate(0)', display: 'block' })),
  state(
    'finalReverse',
    style({ transform: 'rotate(-180deg)', display: 'block' })
  ),

  transition('initialReverse => finalReverse', animate('200ms')),
  transition('finalReverse => initialReverse', animate('200ms')),

  transition('initial => final', animate('200ms')),
  transition('final => initial', animate('200ms')),
]);
